import { render } from "./OfficeMaterialIcon.vue?vue&type=template&id=f4dc9b4c&ts=true"
import script from "./OfficeMaterialIcon.ts?vue&type=script&lang=ts"
export * from "./OfficeMaterialIcon.ts?vue&type=script&lang=ts"

import exportComponent from "/github/workspace/RC.Estimatifs/rc-estimatifs-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__